import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { Typography } from '@mui/material';

interface NavigationLinkProps {
  href: string;
  label: string;
  icon?: ReactNode;
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
  variant?: 'mobile' | 'desktop';
}

export const NavigationLink = ({
  href,
  icon,
  label,
  onClick,
  className,
  isActive = false,
  variant = 'desktop',
}: NavigationLinkProps) => {
  if (variant === 'desktop') {
    return (
      <Link
        to={href}
        className={twMerge(
          'text-black-primary hover:text-blue-primary flex h-10 items-center rounded-none border-b-2 border-solid border-transparent px-4 py-2 font-semibold',
          isActive && 'border-blue-primary text-blue-primary'
        )}
      >
        {label}
      </Link>
    );
  }

  return (
    <Link
      to={href}
      onClick={onClick}
      className={twMerge(
        'flex h-11 items-center gap-4 rounded-lg transition-colors',
        className,
        isActive ? 'text-blue-primary' : 'hover:text-blue-primary text-gray-700'
      )}
    >
      {isActive && <div className="bg-blue-primary h-full w-1" />}
      {icon && (
        <div
          className={twMerge(
            '-mr-2 text-lg',
            isActive ? 'text-blue-primary' : 'text-gray-400'
          )}
        >
          {icon}
        </div>
      )}
      <Typography variant="body1" className="font-semibold">
        {label}
      </Typography>
    </Link>
  );
};
